import { Box } from "@mui/material";
import GenericLichenPhoto from "../../assets/images/lichen/phaeophyscia.png";
import PageHeader from "../../components/PageHeader";
import Overview from "./Overview";
import LichenGallery from "./LichenGallery";

const LichenProject = () => {
  return (
    <Box>
      <PageHeader image={GenericLichenPhoto} title="Lichen Flora" />
      <Overview />
      <LichenGallery />
    </Box>
  );
};

export default LichenProject;
